(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[20],{

/***/ "+o/G":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"pagingButton":"_3au2n_","default":"_1Lb9R6","firstButton":"_3V-Mfg","lastButton":"OTUgAO","dotButton":"_1PiYxC","active":"_2Voyyp"};

/***/ }),

/***/ "/0+H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _ampContext = __webpack_require__("lwAK");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "48fX":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("qhzo");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "5fIB":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("7eYB");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "8Kt/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("oI91");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _sideEffect = _interopRequireDefault(__webpack_require__("Xuae"));

var _ampContext = __webpack_require__("lwAK");

var _headManagerContext = __webpack_require__("FYa8");

var _amp = __webpack_require__("/0+H");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports["default"] = _default;

/***/ }),

/***/ "FYa8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react["default"].createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "KNLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/helpers/url/index.js
var helpers_url = __webpack_require__("gjsy");

// EXTERNAL MODULE: ./node_modules/shortid/index.js
var shortid = __webpack_require__("je4i");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/components/desktop/listing/listing-paging/button/styles.module.scss
var styles_module = __webpack_require__("+o/G");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/listing-paging/button/index.jsx
var __jsx = react_default.a.createElement;



var button_PagingButton = function PagingButton(_ref) {
  var firstButton = _ref.firstButton,
      lastButton = _ref.lastButton,
      dotButton = _ref.dotButton,
      currentPage = _ref.currentPage,
      _onClick = _ref.onClick,
      child = _ref.child,
      value = _ref.value,
      dataEjCategory = _ref['data-ej-category'],
      dataEjAction = _ref['data-ej-action'],
      dataEjLabel = _ref['data-ej-label'];
  var classNames = [styles_module_default.a.pagingButton];
  var buttonClassName = null;

  if (firstButton) {
    buttonClassName = styles_module_default.a.firstButton;
  } else if (lastButton) {
    buttonClassName = styles_module_default.a.lastButton;
  } else if (dotButton) {
    buttonClassName = styles_module_default.a.dotButton;
  } else {
    buttonClassName = styles_module_default.a["default"];
  }

  classNames.push(buttonClassName);

  if (currentPage) {
    classNames.push(styles_module_default.a.active);
  }

  return __jsx("li", {
    className: classNames.join(' ')
  }, __jsx("div", {
    className: styles_module_default.a.pagingButton,
    onClick: function onClick() {
      return _onClick(value);
    },
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel,
    "data-test-selector": "listing-pagination-".concat(value)
  }, child));
};

/* harmony default export */ var listing_paging_button = (button_PagingButton);
// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/listing/pagination-e6t/styles.module.scss
var pagination_e6t_styles_module = __webpack_require__("TGiq");
var pagination_e6t_styles_module_default = /*#__PURE__*/__webpack_require__.n(pagination_e6t_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/pagination-e6t/index.jsx
var pagination_e6t_jsx = react_default.a.createElement;







var pagination_e6t_PaginationE6t = function PaginationE6t(props) {
  var _options;

  var url = props.url,
      totalPagination = props.totalPagination,
      options = props.options,
      defaultValue = props.defaultValue,
      prev = props.prev,
      next = props.next,
      isProjectPage = props.isProjectPage,
      paginationTitle = props.paginationTitle,
      dataEjCategory = props['data-ej-category'],
      dataEjAction = props['data-ej-action'],
      dataEjLabel = props['data-ej-label'],
      isShowcasePage = props.isShowcasePage;
  var currentPage = defaultValue.value;

  var getPageTitle = function getPageTitle(pageNumber) {
    if (!paginationTitle) return undefined;
    var number = parseInt(pageNumber, 10);
    return number === 1 ? paginationTitle : "".concat(paginationTitle, " ").concat(number, ". Sayfa");
  };

  var showFirstItem = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) > 4;
  var showLastItem = Number((_options = options[options.length - 1]) === null || _options === void 0 ? void 0 : _options.label) < Number(totalPagination.label);
  return pagination_e6t_jsx("div", {
    className: pagination_e6t_styles_module_default.a.paginationContainer
  }, pagination_e6t_jsx("ul", {
    className: pagination_e6t_styles_module_default.a.pagination
  }, prev && pagination_e6t_jsx(listing_paging_button, {
    child: pagination_e6t_jsx("a", {
      href: prev,
      title: getPageTitle(currentPage - 1),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel).concat(currentPage - 1)
    }, pagination_e6t_jsx(desktop_elements["e" /* Icon */], {
      name: "navigate_before"
    }), ' Önceki'),
    firstButton: true,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel).concat(currentPage + 1)
  }), showFirstItem && pagination_e6t_jsx(react_default.a.Fragment, null, pagination_e6t_jsx(listing_paging_button, {
    key: shortid_default.a.generate(),
    child: pagination_e6t_jsx("a", {
      href: Object(helpers_url["a" /* createPaginationUrl */])({
        url: url,
        page: 1,
        isProjectPage: isProjectPage,
        isShowcasePage: isShowcasePage
      }),
      title: getPageTitle(1),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction,
      "data-ej-label": "".concat(dataEjLabel, 1)
    }, 1),
    value: 1,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, 1)
  }), pagination_e6t_jsx(listing_paging_button, {
    dotButton: true,
    child: pagination_e6t_jsx("span", null, "..."),
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": "".concat(dataEjLabel, "dot")
  })), options.map(function (pageItem) {
    var pageNumber = pageItem.value;
    var hrefValue = Object(helpers_url["a" /* createPaginationUrl */])({
      url: url,
      page: pageNumber,
      isProjectPage: isProjectPage,
      isShowcasePage: isShowcasePage
    });
    return pagination_e6t_jsx(listing_paging_button, {
      key: shortid_default.a.generate(),
      child: pageNumber === currentPage ? pagination_e6t_jsx("span", {
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction
      }, pageNumber) : pagination_e6t_jsx("a", {
        href: hrefValue,
        title: getPageTitle(pageNumber),
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction
      }, pageNumber),
      value: pageNumber,
      currentPage: pageNumber === currentPage,
      onClick: function onClick() {},
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction
    });
  }), showLastItem && pagination_e6t_jsx(react_default.a.Fragment, null, pagination_e6t_jsx(listing_paging_button, {
    dotButton: true,
    child: pagination_e6t_jsx("span", null, "..."),
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction
  }), pagination_e6t_jsx(listing_paging_button, {
    key: shortid_default.a.generate(),
    child: pagination_e6t_jsx("a", {
      href: totalPagination.url,
      title: getPageTitle(Number(totalPagination.label)),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction
    }, totalPagination.label),
    value: totalPagination.label,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction
  })), next && pagination_e6t_jsx(listing_paging_button, {
    child: pagination_e6t_jsx("a", {
      href: next,
      title: getPageTitle(currentPage + 1),
      "data-ej-category": dataEjCategory,
      "data-ej-action": dataEjAction
    }, 'Sonraki ', pagination_e6t_jsx(desktop_elements["e" /* Icon */], {
      name: "navigate_next"
    })),
    lastButton: true,
    onClick: function onClick() {},
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction
  })));
};

/* harmony default export */ var pagination_e6t = (pagination_e6t_PaginationE6t);
// EXTERNAL MODULE: ./src/components/desktop/listing/pagination-wrapper-e6t/styles.module.scss
var pagination_wrapper_e6t_styles_module = __webpack_require__("L2oU");
var pagination_wrapper_e6t_styles_module_default = /*#__PURE__*/__webpack_require__.n(pagination_wrapper_e6t_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/listing/pagination-wrapper-e6t/index.jsx
var pagination_wrapper_e6t_jsx = react_default.a.createElement;





var pagination_wrapper_e6t_PaginationWrapper = function PaginationWrapper(_ref) {
  var pagination = _ref.pagination,
      url = _ref.url,
      maximumPage = _ref.maximumPage,
      totalListingCount = _ref.totalListingCount,
      isAgentPage = _ref.isAgentPage,
      isProjectPage = _ref.isProjectPage,
      isShowcasePage = _ref.isShowcasePage,
      paginationTitle = _ref.paginationTitle;

  var _ref2 = pagination || {},
      page = _ref2.page,
      pageSize = _ref2.pageSize;

  var hasPageNumber = typeof page === 'number' && page > 0;
  var currentPagination = hasPageNumber ? page : 1;
  var defaultPageNumber = isAgentPage ? 28 : 30;
  var countOfListingsShowed = pageSize || defaultPageNumber;
  var maxPaginationCount = Object(helpers_url["e" /* getMaxPaginationCount */])({
    maximumPage: maximumPage,
    totalListingCount: totalListingCount,
    countOfListingShowed: countOfListingsShowed
  });
  var prevPaginationUrl = currentPagination > 1 && Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: currentPagination - 1,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var nextPaginationUrl = currentPagination !== maxPaginationCount && Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: currentPagination + 1,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var lastPaginationUrl = Object(helpers_url["a" /* createPaginationUrl */])({
    url: url,
    page: maxPaginationCount,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage
  });
  var paginationList = Object(helpers_url["d" /* getLimitedPaginationList */])({
    maxPaginationCount: maxPaginationCount,
    currentPage: currentPagination,
    range: 5
  });
  var isFirstPage = currentPagination === 0;
  var firstPageNumberMultiplier = isFirstPage ? currentPagination : currentPagination - 1; // The range of the listings that are shown on the page. Eg 1-30, 31-60, 61-90. This param shows the initial index of the range.

  var shownListingsRangeInitialIndex = firstPageNumberMultiplier * countOfListingsShowed + 1;
  var isLastPage = currentPagination === maxPaginationCount;
  var shownListingsRangeLastIndex = shownListingsRangeInitialIndex + countOfListingsShowed - 1; // In case the listings are limited (for 30k listings we show max 1500 of them with 50 pages), the last index of the range will be the pageSize*50.

  var isListingsLimited = shownListingsRangeLastIndex < totalListingCount; // To ensure the the readibility of the code, we have created a function to get the last index of the range of the listings that are shown on the page and ignore code duplication.

  var getMaxShownListingsCount = function getMaxShownListingsCount() {
    if (!isLastPage) return shownListingsRangeLastIndex;
    if (isListingsLimited) return shownListingsRangeLastIndex;
    return totalListingCount;
  };

  var displayedListingsCountLastIndex = getMaxShownListingsCount();
  return pagination_wrapper_e6t_jsx(react_default.a.Fragment, null, paginationList.length > 1 && pagination_wrapper_e6t_jsx("div", {
    className: pagination_wrapper_e6t_styles_module_default.a.wrapper
  }, pagination_wrapper_e6t_jsx(pagination_e6t, {
    url: url,
    prev: prevPaginationUrl,
    next: nextPaginationUrl,
    totalPagination: {
      url: lastPaginationUrl,
      label: maxPaginationCount
    },
    defaultValue: {
      value: currentPagination,
      label: currentPagination
    },
    options: paginationList,
    isProjectPage: isProjectPage,
    isShowcasePage: isShowcasePage,
    paginationTitle: paginationTitle
  }), pagination_wrapper_e6t_jsx("div", {
    className: pagination_wrapper_e6t_styles_module_default.a.subText
  }, "".concat(shownListingsRangeInitialIndex, " - ").concat(displayedListingsCountLastIndex, " aras\u0131ndaki ilanlar listeleniyor."))));
};

/* harmony default export */ var pagination_wrapper_e6t = __webpack_exports__["a"] = (pagination_wrapper_e6t_PaginationWrapper);

/***/ }),

/***/ "L2oU":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2wHxkP","subText":"_2c4dB7"};

/***/ }),

/***/ "LmzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("w/K5");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var style = {
  maxWidth: 1260,
  margin: '0px auto'
};

var Content = function Content(_ref) {
  var _classNames;

  var inline = _ref.inline,
      children = _ref.children,
      transparent = _ref.transparent,
      className = _ref.className;
  var mainClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.main, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.transparent, transparent), _classNames));
  var contentClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.content, true));
  return __jsx("div", {
    style: inline ? style : null,
    className: contentClass
  }, children);
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ "T0f4":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "TGiq":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"_2Tfd5Q","pagination":"_49yNIg"};

/***/ }),

/***/ "Xuae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__("mPvQ");

var _classCallCheck = __webpack_require__("/GRZ");

var _createClass = __webpack_require__("i2R6");

var _assertThisInitialized = __webpack_require__("qXWd");

var _inherits = __webpack_require__("48fX");

var _possibleConstructorReturn = __webpack_require__("tCBg");

var _getPrototypeOf = __webpack_require__("T0f4");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__("q1tI");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports["default"] = _default;

/***/ }),

/***/ "cA7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var styles = {
  badge: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '21px',
    letterSpacing: 'normal',
    textAlign: 'center',
    height: '20px',
    color: '#fff',
    borderRadius: 3,
    padding: '0 5px',
    marginBottom: 5,
    zIndex: 1
  }
};

var getBackgroundColor = function getBackgroundColor(type) {
  switch (type) {
    case 'new':
      return '#f16666';

    case 'promotion':
      return '#ffaa19';

    case 'opportunity':
      return '#58b847';

    case 'premium':
      return '#5f787e';

    case 'proje':
      return '#52ca46';

    case 'INSTALMENT':
      return '#ffffff';

    case 'DELAY':
      return '#ffffff';

    case 'DEPLETABLE':
      return '#ffffff';

    case 'ramadan':
      return "#7e56c6";

    case 'platinum':
      return "#2C394D";

    default:
      return null;
  }
};

var getBadgeName = function getBadgeName(type, data) {
  switch (type) {
    case 'new':
      return 'YENİ';

    case 'promotion':
      return 'ÖNE ÇIKAN';

    case 'opportunity':
      return 'JETFIRSAT';

    case 'premium':
      return 'PREMIUM';

    case 'proje':
      return 'PROJE';

    case 'INSTALMENT':
      return "".concat(data === null || data === void 0 ? void 0 : data.title, " AY TAKS\u0130T");

    case 'DELAY':
      return "".concat(data === null || data === void 0 ? void 0 : data.title, " AY VADE");

    case 'DEPLETABLE':
      return "T\xDCKENMEK \xDCZERE";

    case 'ramadan':
      return "RAMAZAN FIRSATI";

    case 'platinum':
      return "PLAT\u0130N";

    default:
      return null;
  }
};

var BadgeCardE6t = function BadgeCardE6t(props) {
  var _props$inline = props.inline,
      inline = _props$inline === void 0 ? true : _props$inline,
      style = props.style,
      type = props.type,
      data = props.data;
  var name = getBadgeName(type, data);
  if (!name) return null;
  var backgroundColor = getBackgroundColor(type);
  var campainClass = data && 'campain';
  var badgeStyle = inline ? _objectSpread(_objectSpread(_objectSpread({}, styles.badge), style), {}, {
    backgroundColor: backgroundColor
  }) : _objectSpread(_objectSpread({}, style), {}, {
    backgroundColor: backgroundColor
  });
  return __jsx("div", {
    className: campainClass,
    style: badgeStyle
  }, name);
};

/* harmony default export */ __webpack_exports__["a"] = (BadgeCardE6t);

/***/ }),

/***/ "g4pe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8Kt/")


/***/ }),

/***/ "kG2m":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "lwAK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = /*#__PURE__*/_react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "mPvQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("5fIB");

var iterableToArray = __webpack_require__("rlHP");

var unsupportedIterableToArray = __webpack_require__("KckH");

var nonIterableSpread = __webpack_require__("kG2m");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "oI91":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "qXWd":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "rlHP":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "tCBg":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("C+bE");

var assertThisInitialized = __webpack_require__("qXWd");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "w/K5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"_2-gYBG","transparent":"_5SI07-","content":"mrwLbC"};

/***/ })

}]);